import { type DataNode, Select } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { useVirtualMachineConfig } from "@/organisms/Drawers/applications/inventory/useInventory"
import { CorrelationFieldsTemplate } from "@/organisms/Drawers/components/CorrelationFieldsTemplate"
import { Form } from "@/organisms/Form"
import { ProjectSelect } from "../ProjectSelect"

import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"

export const FormConfigurationTabVirtualMachineDrawer = (
  props: TabComponentProps & {
    isPathSelected?: boolean
    isRootSelected?: boolean
    tree: DataNode[]
    context: ReturnType<typeof useVirtualMachineConfig>
  }
) => {
  const { t } = useTranslation()
  const { form, message } = Form.useForm()
  const { isPathSelected, isRootSelected, context, tree } = props
  const { updateConfig } = context
  const projectSelectedByPath = Form.useWatch("projectSelectedByPath", form)

  return (
    <CorrelationFieldsTemplate
      hide={!isPathSelected}
      isSelected={projectSelectedByPath}
    >
      <Form
        layout="vertical"
        form={form}
        disabled={context.isUpdating}
        onFinish={async (values) => {
          try {
            await updateConfig(
              values,
              isRootSelected && tree?.[0]?.children?.map?.((child) => child.key)
            )

            form.setFieldsValue({
              projectSelectedByPath: true,
              somePathCorrelatedToProject: false
            })
            message.onSuccess(
              isRootSelected
                ? "VM correlated successfully"
                : "Paths correlated successfully ",
              { action: "none" }
            )
          } catch (_: unknown) {
            message.onFailed("Failed to correlate", { action: "updated" })
          }
        }}
      >
        <Form.Item name="pathSelected" label="Selected">
          <Select mode="multiple" notFoundContent={null} />
        </Form.Item>
        <Form.Item
          required={false}
          rules={[{ required: true, message: t("error.requiredField") }]}
          name="correlateToProject"
          label="Correlate to project"
        >
          <ProjectSelect />
        </Form.Item>
        <Form.Item hidden name="project" />
        <Form.Item hidden name="projectSelectedByPath" />
        <Form.Item hidden name="somePathCorrelatedToProject" />
      </Form>
    </CorrelationFieldsTemplate>
  )
}
